import { createFileRoute } from '@tanstack/react-router'
import { GalleryRouteComponent } from '@/components/gallery/GalleryRouteComponent'

export const Route = createFileRoute('/gallery/')({
	head: () => ({
		meta: [
			{ title: 'WellView Care | Gallery | Non-Profit Healthcare Organization' },
			{
				name: 'description',
				content:
					'Discover WellView Care, a 501(c)(3) Non-Profit Organization dedicated to healthcare equity, HIV eradication, and Hepatitis C treatment.' +
					' Learn about our mission and commitment to comprehensive care for all.',
			},
			{
				name: 'keywords',
				content: 'Non-Profit Healthcare, HIV Eradication, Hepatitis C Treatment, PrEP Services, Healthcare Equity',
			},
		],
	}),
	component: GalleryRouteComponent,
})
